import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import navigationService from 'src/utils/navigation';
import routeNames from 'src/constants/routeNames';

const style = {
  height: 50,
  width: 40,
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 0,
};

const GoBackButton = ({ canGoBack, onPress, backImage }) => {
  const pathName = window.location.pathname;

  if (!canGoBack) {
    if (pathName === '/chat') {
      return (
        <TouchableOpacity style={style} onPress={() => navigationService.navigate(routeNames.NOW)}>
          {backImage()}
        </TouchableOpacity>
      );
    }

    return null;
  }

  return (
    <TouchableOpacity style={style} onPress={onPress} testID="go-back-button">
      {backImage()}
    </TouchableOpacity>
  );
};

GoBackButton.defaultProps = {
  canGoBack: false,
  backImage: () => {},
  onPress: () => {},
};

GoBackButton.propTypes = {
  canGoBack: PropTypes.bool,
  onPress: PropTypes.func,
  backImage: PropTypes.func,
};

export default GoBackButton;
